interface CaptionedImageProps {
  src: string;
  id: string;
  caption: string;
}
function CaptionedImage(props: CaptionedImageProps): JSX.Element {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-3 rounded-md border-2 border-solid border-gray p-3">
      <img className="h-auto max-h-[500px]" src={props.src} alt="missingImg" />
      <hr className="w-full border-2 border-solid border-gray"></hr>
      <p className="font-thin">{props.caption}</p>
    </div>
  )
}

export default CaptionedImage;
